// application/models/IRelatorioDash.ts

export enum FileType {
  CSV = 'csv',
  XLSX = 'xlsx',
  TXT = 'txt',
  ZIP = 'zip'
}

export enum RelatorioStatus {
  EM_FILA = 1,       // 20%
  EM_ANDAMENTO = 2, // 20–60%
  PROCESSADO = 3,   // 100%
  ERRO = 4
}

export function getRelatorioProgress(status: number | string | undefined): number {
  if (status === undefined || status === null) return 0;
  const id = typeof status === 'string'
    ? { EM_FILA: 1, EM_ANDAMENTO: 2, PROCESSADO: 3, ERRO: 4 }[status] ?? 0
    : status;
  switch (id) {
    case RelatorioStatus.EM_FILA: return 20;
    case RelatorioStatus.EM_ANDAMENTO: return 60;
    case RelatorioStatus.PROCESSADO: return 100;
    case RelatorioStatus.ERRO: return 0;
    default: return 0;
  }
}

export interface IRelatorioDashRequest {
    generateFiles?: boolean
    format?: FileType.CSV | FileType.XLSX | FileType.TXT
    customTitle?: string
    customSubtitle?: string
    includeTotal?: boolean
    totalLabel?: string
    sheetName?: string
}

export interface IRelatorioAcessFileItem {
  filename: string;
  path?: string;
  size?: number;
  type: string;
  downloadUrl: string;
}

export interface IRelatorioAcessRow {
  Quantidade?: number | string;
  RazaoSocial?: string;
  NomeFantasia?: string;
  LoginCliente?: string;
  Nome?: string;
  IdTipoConsumo?: number | string;
  Descricao?: string;
  IdUsuario?: string;
  LoginUsuario?: string;
}

export interface IRelatorioAcessSource {
  status?: number | string;
  statusText?: string;
  message?: string;
  data?: IRelatorioAcessRow[];
  count?: unknown;
  Erro?: string;
  files?: IRelatorioAcessFileItem[];
}

export interface IRelatorioConsumoAnalyticFileItem {
  filename: string;
  path?: string;
  size?: number;
  type: string;
  downloadUrl: string;
}

export interface IRelatorioConsumoAnalyticSource {
  status?: number | string;
  statusText?: string;
  message?: string;
  data?: any[];
  count?: unknown;
  Erro?: string;
  files?: IRelatorioConsumoAnalyticFileItem[];
  totalFiles?: number;
  totalSize?: number;
}

// 1. Acess (já existe)
export interface IRelatorioAcessRequest extends IRelatorioDashRequest {
    IDCLIENTE: number
    RAZAO_SOCIAL_CLIENTE?: string
    IDUSUARIO?: number
    IDUSUARIO_VENDEDOR?: number
    IDUSUARIO_REQUISICAO?: number
    TIPOCONSUMO?: number
    DATAINICIO?: string
    DATAFIM?: string
}

// 2. Quantitative (já existe)
export interface IRelatorioQuantitativeRequest extends IRelatorioDashRequest {
    IDPRODUTO: number
    IDCLIENTE: number
    IDUSUARIO?: number
    TIPOCONSUMO?: number
    DATAINICIO: string
    DATAFIM: string
}

// 3. Syntetic (NOVO)
export interface IRelatorioSynteticRequest extends IRelatorioDashRequest {
    IDCLIENTE: number
    IDUSUARIO?: number
    IDUSUARIO_VENDEDOR?: number
    TIPOCONSUMO?: number
    DATAINICIO?: string
    DATAFIM?: string
}

// 4. Receita (NOVO)
export interface IRelatorioReceitaRequest extends IRelatorioDashRequest {
    MesReferencia: number | string
    AnoReferencia: number | string
}

// 5. Consumo Analytic (NOVO)
export interface IRelatorioConsumoAnalyticRequest extends Omit<IRelatorioDashRequest, 'format'> {
    format: FileType.CSV | FileType.XLSX | FileType.TXT
    PAGENUMBER?: number  // Opcional - não usado no backend (sempre retorna todos os dados)
    PAGESIZE?: number    // Opcional - não usado no backend (sempre retorna todos os dados)
    IDPRODUTO?: number
    IDCLIENTE?: number
    IDUSUARIO?: number
    IDUSUARIO_VENDEDOR?: number
    TIPOCONSUMO?: number
    DATAINICIO?: string
    DATAFIM?: string
    RAZAO_SOCIAL_CLIENTE?: string
    IDUSUARIO_REQUISICAO?: number
}

// 6. Unificado Sintético/Quantitativo (NOVO)
export interface IRelatorioSinteticoQuantitativoRequest extends IRelatorioDashRequest {
    tipoRelatorio: 'sintetico' | 'quantitativo'
    IDPRODUTO?: number        // Obrigatório apenas para quantitativo
    IDCLIENTE: number
    IDUSUARIO?: number
    IDUSUARIO_VENDEDOR?: number  // Apenas para sintético
    TIPOCONSUMO?: number
    DATAINICIO: string        // Obrigatório para quantitativo
    DATAFIM: string          // Obrigatório para quantitativo
}

// Interface para relatório
export interface IRelatorioItem {
  IdRelatorioFila: number
  statusText: string
  hasFiles: boolean
  files?: Array<{
      filename: string
      downloadUrl: string
      size: number
      type: string
  }>
  [key: string]: any
}

export interface IRelatorioComMudancas extends IRelatorioItem {
  _deveAtualizar: boolean
}
